import { leadConstant } from '../constants';
import { getLeadStatuses } from '@/services/leadStatusService';
import { postRequest } from '@/utils/apiHelper';

/**
 * Fetch and store lead statuses in Redux (called once globally)
 */
export const fetchLeadStatuses = () => async (dispatch) => {
  dispatch({ type: leadConstant.LOADING_LEAD_STATUSES, payload: true });
  
  try {
    const statuses = await getLeadStatuses();
    dispatch({
      type: leadConstant.SET_LEAD_STATUSES,
      payload: statuses,
    });
  } catch (error) {
    console.error('Failed to fetch lead statuses:', error);
  } finally {
    dispatch({ type: leadConstant.LOADING_LEAD_STATUSES, payload: false });
  }
};

/**
 * Fetch and store agency members in Redux (called once globally)
 */
export const fetchAgencyMembers = (agencyId) => async (dispatch) => {
  if (!agencyId) return;
  
  dispatch({ type: leadConstant.LOADING_AGENCY_MEMBERS, payload: true });
  
  try {
    const response = await postRequest(
      'userAgency/getAgencyMembers',
      { agency_id: agencyId },
      false,
      undefined,
      'default',
      undefined
    );

    if (response?.data && Array.isArray(response.data)) {
      const members = response.data.map((member) => ({
        id: String(member.id),
        text: `${member.first_name || ''} ${member.last_name || ''}`.trim() || String(member.id),
        first_name: member.first_name,
        last_name: member.last_name,
        email: member.email,
      }));
      
      dispatch({
        type: leadConstant.SET_AGENCY_MEMBERS,
        payload: members,
      });
    }
  } catch (error) {
    console.error('Failed to fetch agency members:', error);
  } finally {
    dispatch({ type: leadConstant.LOADING_AGENCY_MEMBERS, payload: false });
  }
};
